import { NgSwitch, NgTemplateOutlet } from '@angular/common';
import { Component, inject } from '@angular/core';
import { InfoModal } from '@shared/core/enums/info-modal-template.enum';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-info-modal',
  standalone: true,
  imports: [NgSwitch, NgTemplateOutlet],
  templateUrl: './info-modal.component.html',
  styleUrl: './info-modal.component.scss',
})
export class InfoModalComponent {
  private readonly dialogConfig = inject(DynamicDialogConfig);

  public dialogDataTemplate = this.dialogConfig.data?.template || InfoModal.DISALLOWED_STATES;

  public readonly TEMPLATE = InfoModal;

  public readonly links = {
    independentSearch: 'https://www.squaremouth.com/single-trip?aid=20202-11634',
    assistedSearch: 'https://www.insuranceconsultantsintl.com/amac-quote-page',
  };
}
